import { useEffect, useRef } from "react";
import { useNotificationsRequest } from "hooks/useNotificationsRequest";
import { useSoundPath } from "hooks/useSoundPath";
import NotificationsList from "./NotificationsList";
import useProfile from "hooks/useProfile";


const PageHeaderUserNotifications = () => {
  const { notificationsList } = useProfile();
  const {clearNotifications, clearNotification} = useNotificationsRequest();
  const oldNotificationsList = useRef([]);
  const playSound = useSoundPath();

  useEffect(() => {
    if (JSON.stringify(notificationsList) !== JSON.stringify(oldNotificationsList.current) && notificationsList.length > 0) {
      playSound('notifications');
      oldNotificationsList.current = [...notificationsList];
    }
  }, [notificationsList, playSound]);

  return (
    <>
      <button className="page-header__user-notifications">
        {notificationsList.length ? (
          <span>{notificationsList.length}</span>
        ) : null}
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.33318 14.5H6.66652M11.9998 5.83337C11.9998 4.77251 11.5784 3.75509 10.8283 3.00495C10.0781 2.2548 9.06072 1.83337 7.99985 1.83337C6.93898 1.83337 5.92157 2.2548 5.17142 3.00495C4.42128 3.75509 3.99985 4.77251 3.99985 5.83337C3.99985 7.8935 3.48016 9.30401 2.89963 10.237C2.40993 11.024 2.16509 11.4174 2.17407 11.5272C2.18401 11.6488 2.20976 11.6951 2.3077 11.7678C2.39616 11.8334 2.79491 11.8334 3.59242 11.8334H12.4073C13.2048 11.8334 13.6035 11.8334 13.692 11.7678C13.7899 11.6951 13.8157 11.6488 13.8256 11.5272C13.8346 11.4174 13.5898 11.024 13.1001 10.237C12.5195 9.30401 11.9998 7.8935 11.9998 5.83337Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <section className="page-header__user-popup page-header__user-popup--notifications">
        <b className="page-header__user-popup-title">
          Notifications
          {notificationsList.length >= 1 && (
            <button className="page-header__user-popup-clear" onClick={() => clearNotifications()}>Clear</button>
          )}
        </b>
        {notificationsList.length ? (
          <NotificationsList list={notificationsList} clearNotification={clearNotification} />
        ) : (
          <p className="page-header__user-popup-empty">
            There's no notifications yet
          </p>
        )}
      </section>
    </>
  );
};

export default PageHeaderUserNotifications;
